module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('NbPagerSelection', {
    attrs: {
      "pager": _vm.pager,
      "activeItem": _vm.activePerson
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.activePerson.name ? "#" + _vm.activePerson.id + " " + _vm.activePerson.name : "请选择人物...") + "\n\t\t")]), _vm._v(" "), _vm._l((_vm.pager.persons), function(person) {
    return _c('div', {
      staticClass: "mb10 p10 cursor br4 border",
      class: {
        'bg-white': person.id !== _vm.activePerson.id, 'bg-azure': person.id === _vm.activePerson.id
      },
      attrs: {
        "slot": "cells"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.clickItem(person)
        }
      },
      slot: "cells"
    }, [_c('div', {
      staticClass: "media"
    }, [_c('div', {
      staticClass: "pull-left"
    }, [(person.image && person.image.url) ? _c('img', {
      staticClass: "img-rounded w120",
      attrs: {
        "src": person.image.url
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "media-body"
    }, [_c('div', [_c('span', {
      staticClass: " f18 black"
    }, [_vm._v(_vm._s(person.name))])]), _vm._v(" "), (person.title) ? _c('div', {
      staticClass: "mv5"
    }, [_vm._v("\n\t\t\t\t\t\t头衔：" + _vm._s(person.title) + "\n\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (person.phone) ? _c('div', {
      staticClass: "mv5"
    }, [_vm._v("\n\t\t\t\t\t\t电话：" + _vm._s(person.phone) + "\n\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (person.office) ? _c('div', {
      staticClass: "mv5"
    }, [_vm._v("\n\t\t\t\t\t\t办公地点：" + _vm._s(person.office) + "\n\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (person.email) ? _c('div', {
      staticClass: "mv5"
    }, [_vm._v("\n\t\t\t\t\t\t邮件：" + _vm._s(person.email) + "\n\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "mr10"
    }, [_vm._v("#" + _vm._s(person.id))]), _vm._v(" "), _c('span', {
      staticClass: "mr10"
    }, [_vm._v("创建于:" + _vm._s(_vm._f("simpleDate")(person.createTime)))])])])])])
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-57607e81"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/backyard/view/person/Selection.vue
// module id = 986
// module chunks = 1